import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import Navbar from "./Components/Navbar";
import Intro from "./Components/Intro";
import CursorGlow from "./Components/CursorGlow";
import ProjectPage from "./Components/ProjectPage";
import {
  Hero,
  FocusStrip,
  ProofStrip,
  About,
  Services,
  Projects,
  Toolkit,
  Contact,
  Footer,
} from "./Components/Sections";

/** Scrolls to the hash target after a route change, or to the top of a new page. */
function ScrollManager() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) {
      const target = document.getElementById(hash.slice(1));
      if (target) {
        const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
        target.scrollIntoView({ behavior: reduce ? "auto" : "smooth", block: "start" });
        return;
      }
    }
    window.scrollTo({ top: 0, behavior: "auto" });
  }, [pathname, hash]);

  return null;
}

function Home() {
  return (
    <main className="page">
      <Hero />
      <FocusStrip />
      <ProofStrip />
      <About />
      <Services />
      <Projects />
      <Toolkit />
      <Contact />
    </main>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <ScrollManager />
      <Intro />

      <div className="canvas" aria-hidden="true">
        <div className="canvas__base" />
        <div className="canvas__aurora" />
        <div className="canvas__grid" />
        <div className="canvas__noise" />
      </div>

      <CursorGlow />
      <Navbar />

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/portfolio/:slug" element={<ProjectPage />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>

      <Footer />
    </BrowserRouter>
  );
}
